import React from "react";
import LegacyStyle from '../../styles/components/layout/BlurPlan.module.css';
import RedesignStyle from '../../styles/components/layout/BlurPlanRedesign.module.scss';
import { FaLock } from "react-icons/fa";

/**
 * BlurPlan
 * - Se locked=true → aplica blur e bloqueia interação
 * - Se locked=false → renderiza normal
 *
 * Props:
 * - locked: boolean (ex: plano gratuito)
 * - children: conteúdo que vai ficar blur
 * - onUnlock: função (ex: abrir modal premium)
 * - message: texto opcional
 */
export default function BlurPlan({
  redesign = false,
  locked,
  children,
  onUnlock,
  message = "Você pode visualizar somente dados básicos no plano gratuito",
  blur = 7,
}) {
  const Style = redesign ? RedesignStyle : LegacyStyle;
  if (!locked) return <>{children}</>;

  return (
    <div className={Style.wrapper}>
      <div
        className={Style.content}
        style={{ filter: `blur(${blur}px)` }}
        aria-hidden="true"
      >
        {children}
      </div>

      <div className={Style.overlay}>
            <div className={Style.card}>
                <div className={Style.lock}>
                    <FaLock />
                </div>
                <p className={Style.text}>{message}</p>

                {onUnlock && (
                    <button type="button" className={Style.button} onClick={onUnlock}>
                        Evoluir meu plano
                    </button>
                )}
            </div>
      </div>
    </div>
  );
}
